import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { StorePostType } from "types/PostTypes";

export const useStorePost = (
  options?: UseMutationOptions<any, Error, StorePostType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["storePost"],
    mutationFn: async (data) => {
      const formData = new FormData();
      formData.append("title", `${data?.title}`);
      formData.append("status", `${data?.status}`);
      formData.append("content", `${data?.content}`);
      formData.append("description", `${data?.description}`);
      if (data.file) {
        formData.append("file", data.file);
      }

      formData.append("link", `${data.link}`);
      formData.append("source", `${data.source}`);
      formData.append("companyIds", JSON.stringify(data.companyIds));
      formData.append("categoryIds", JSON.stringify(data.categoryIds));
      formData.append("publishedAt", `${data.publishedAt}`);

      return axiosInstance.post(`/posts`, formData).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa dodawanie informacji rynkowej...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "store-post",
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Informacja rynkowa dodana pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "store-post",
      });
      queryClient.invalidateQueries({ queryKey: ["posts"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas dodawania informacji rynkowej.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "store-post",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useStorePost;
